import { useCallback, useState } from "react";

export function useRenderKey(seed: string) {
  const [key, setKey] = useState(seed + Math.random());

  const nextKey = useCallback(() => {
    setKey(seed + Math.random());
  }, []);

  return [key, nextKey] as const;
}
